import { MarketEnum } from "../../../Enums/MarketEnum";
import ValueBoolean from "../../Value/ValueBoolean";
import FixturesModel from "../FixturesModel";

export default class BothTeamsFixtureModel implements FixturesModel {
    public matchId: string = null;
    public market: MarketEnum = MarketEnum.BOTH_TEAMS_SCORE;
    public matchType: string = "FOOTBALL";
    public prediction: ValueBoolean = null;

    constructor(matchId: string, value: boolean) {
        this.matchId = matchId;
        this.prediction = new ValueBoolean();
        this.prediction.value = value;
    }
}